import Vue from 'vue'
import App from './App.vue'
import './assets/css/main.css'

// Import components
import KeywordManager from './components/KeywordManager.vue'
import ContentItem from './components/ContentItem.vue'
import LogViewer from './components/LogViewer.vue'

// Register global components
Vue.component('KeywordManager', KeywordManager)
Vue.component('ContentItem', ContentItem)
Vue.component('LogViewer', LogViewer)

// Configure global properties
Vue.prototype.$formatDate = (date) => {
  if (!date) return 'N/A'
  return new Date(date).toLocaleString()
}

// Create and mount the Vue instance
new Vue({
  render: (h) => h(App),
}).$mount('#app')

console.log('Content Scraper v1.0.0 - Running in development mode')
